import * as React from 'react';
import { useMediaQuery } from 'react-responsive';

import { Breakpoint } from '../../enums';
import { useAfterHydration } from '../../hooks';
import { CollectionBoxItem } from '../../interfaces';

import { 
  BackgroundImage, 
  CollectionBox, 
  CollectionBoxesContainer, 
  CollectionBoxMenuPosition, 
  Container, 
  Label 
} from './collectionBoxes.styled';
import { CollectionBoxesProps } from './collectionBoxes.types';

export const CollectionBoxes: React.FC<CollectionBoxesProps> = (props: CollectionBoxesProps): JSX.Element => {
  const { items, withMobileMosaicTheme = false, className }: CollectionBoxesProps = props;
  const isMobile: boolean = useMediaQuery({ query: Breakpoint.Mobile });
  /**
   * Oba warianty budują inne drzewo: mobilny to pojedyncze pudełka, szeroki opakowuje
   * je parami. Przy podłączaniu aplikacji trzeba więc poczekać — patrz `useAfterHydration`,
   * które jednocześnie pilnuje, żeby komponent montowany PÓŹNIEJ nie płacił za to
   * klatką w układzie szerokim.
   */
  const poPodlaczeniu: boolean = useAfterHydration();
  const shouldUseMobileLayout: boolean = poPodlaczeniu && isMobile && !withMobileMosaicTheme;
  let rowIndex: number = 0;

  return (
    <Container className={className} $withMobileMosaicTheme={withMobileMosaicTheme}>
      {items.map((item: CollectionBoxItem, index: number): JSX.Element | false => {
        rowIndex = index % 2 === 0 ? rowIndex + 1 : rowIndex;
        
        return shouldUseMobileLayout ? (
          item.linkData ? (
            <CollectionBox 
              key={`${item.label ?? ''}-${index}`}
              $isSmallBox={rowIndex % 2 === 0}
              $withMobileMosaicTheme={withMobileMosaicTheme}
            >
              <CollectionBoxMenuPosition {...item.linkData}>
                <BackgroundImage src={item.image} alt={item.label ?? ''} />
                {!!item.label && <Label>{item.label}</Label>}
              </CollectionBoxMenuPosition>
            </CollectionBox>
          ) : (
            <CollectionBox 
              key={`${item.label ?? ''}-${index}`}
              $isSmallBox={rowIndex % 2 === 0}
              $withMobileMosaicTheme={withMobileMosaicTheme}
            >
              <BackgroundImage src={item.image} alt={item.label ?? ''} />
              {!!item.label && <Label>{item.label}</Label>}
            </CollectionBox>
          )
        ) : (
          index % 2 === 0 && (
            item.linkData ? (
              <CollectionBoxesContainer key={`${item.label ?? ''}-${index}`}>
                <CollectionBox 
                  $isSmallBox={!!items[index + 1] && rowIndex % 2 === 0}
                  $withMobileMosaicTheme={!!withMobileMosaicTheme}
                >
                  <CollectionBoxMenuPosition {...item.linkData}>
                    <BackgroundImage src={item.image} alt={item.label ?? ''} />
                    {!!item.label && <Label>{item.label}</Label>}
                  </CollectionBoxMenuPosition>
                </CollectionBox>
                {!!items[index + 1] && (
                  <CollectionBox 
                    $isSmallBox={rowIndex % 2 !== 0}
                    $withMobileMosaicTheme={withMobileMosaicTheme}
                  >
                    <CollectionBoxMenuPosition {...items[index + 1].linkData}>
                      <BackgroundImage src={items[index + 1].image} alt={items[index + 1].label ?? ''} />
                      <Label>{items[index + 1].label}</Label>
                    </CollectionBoxMenuPosition>
                  </CollectionBox>
                )}
              </CollectionBoxesContainer>
            ) : (
              <CollectionBoxesContainer key={`${item.label ?? ''}-${index}`}>
                <CollectionBox 
                  $isSmallBox={!!items[index + 1] && rowIndex % 2 === 0}
                  $withMobileMosaicTheme={withMobileMosaicTheme}
                >
                  <BackgroundImage src={item.image} alt={item.label ?? ''} />
                  {!!item.label && <Label>{item.label}</Label>}
                </CollectionBox>
                {!!items[index + 1] && (
                  <CollectionBox 
                    $isSmallBox={rowIndex % 2 !== 0}
                    $withMobileMosaicTheme={withMobileMosaicTheme}
                  >
                    <BackgroundImage src={items[index + 1].image} alt={items[index + 1].label ?? ''} />
                    <Label>{items[index + 1].label}</Label>
                  </CollectionBox>
                )}
              </CollectionBoxesContainer>
            )
          )
        );
      })}
    </Container>
  );
};
